import React from "react";
import { HowToBuyFAQsContainer } from "./style";
import type { EntryCollection } from "contentful";
import type { FAQItemContentModel } from "types/contentful";
import HowToBuyFAQ from "./HowToBuyFAQ";

interface HowToBuyFAQsComponentProps {
  relatedFaqs: EntryCollection<FAQItemContentModel>;
}

const HowToBuyFAQs = (props: HowToBuyFAQsComponentProps) => {
  const { relatedFaqs = [] } = props;
  const cleanedRelatedFaqs = JSON.parse(JSON.stringify(relatedFaqs));

  if (!Array.isArray(cleanedRelatedFaqs) || cleanedRelatedFaqs.length === 0) {
    return null;
  }

  return (
    <HowToBuyFAQsContainer>
      <HowToBuyFAQ cleanedFAQArray={cleanedRelatedFaqs} />
    </HowToBuyFAQsContainer>
  );
};
export default HowToBuyFAQs;
